import { ScrollArea } from '@/components/ui/scroll-area';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { menuSections } from '@/config/navigation-config';
import { SidebarFooter } from './sidebar-footer';
import { SidebarHeader } from './sidebar-header';
import { SidebarMenuSection } from './sidebar-menu-section';
import { MobileSidebarProps } from './types';

export function MobileSidebar({
  isOpen,
  onClose,
  currentPath,
  openSubMenus,
  onNavigate,
  onToggleSubMenu,
}: MobileSidebarProps) {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent
        side="left"
        className="w-64 p-0 bg-blue-900 text-white border-blue-800 sm:max-w-[16rem]"
      >
        <div className="flex flex-col h-full">
          <SidebarHeader isCollapsed={false} onClose={onClose} isMobile={true} />
          <ScrollArea className="flex-1">
            <div className="py-2">
              {menuSections.map((section, sectionIndex) => (
                <SidebarMenuSection
                  key={sectionIndex}
                  section={section}
                  currentPath={currentPath}
                  isCollapsed={false}
                  openSubMenus={openSubMenus}
                  onNavigate={onNavigate}
                  onToggleSubMenu={onToggleSubMenu}
                />
              ))}
            </div>
          </ScrollArea>
          <SidebarFooter isCollapsed={false} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
